import React, { useContext, useEffect } from 'react';
import { GTM_Page_Intermediaria } from 'components/GoogleTagManager';
import { PesquisaContext } from 'pages/home/context/PesquisaContext';
import { useHistory } from 'react-router-dom';
import { SuporteContainer } from './Suporte.styled';
import BarraPesquisa from 'pages/pesquisa/barraPesquisa/BarraPesquisa';
import IntermediatePage from '../components/IntermediatePage';
import DynamicHeader from 'components/dynamic_header/DynamicHeader';
import IaraSection from './components/IaraSection';

export interface ISuporte {}

const Suporte = ({}: ISuporte) => {
    const history = useHistory();
    const { isSearchView } = useContext(PesquisaContext.Context);

    const load = async () => {
        setTimeout(() => {
            window.scrollTo(0, 0);
        }, 100);
    };

    useEffect(() => {
        load();
    }, []);

    return (
        <>
            <DynamicHeader />

            <IntermediatePage
                highlightedBanner
                helmetTitle={'Suporte'}
                helmetMetaDescription={''}
                title1={''}
                title2={'Fale com a Iara'}
                subtitle="A Inteligência Artificial para Rede de Aprendizagem do Instituto Ayrton Senna."
                onBackClick={() => {
                    GTM_Page_Intermediaria('suporte_intermediaria', 'voltar_pagina_btn');
                    history.push('/');
                }}
            >
                <SuporteContainer>
                    <IaraSection />
                </SuporteContainer>
            </IntermediatePage>

            {/* {isSearchView && <BarraPesquisa />} */}
        </>
    );
};

export default Suporte;
